import { render } from "./ColumnOffset.vue?vue&type=template&id=1d0d9d1f&scoped=true"
import script from "./ColumnOffset.vue?vue&type=script&lang=ts"
export * from "./ColumnOffset.vue?vue&type=script&lang=ts"

import "./ColumnOffset.vue?vue&type=style&index=0&id=1d0d9d1f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1d0d9d1f"

export default script